import { formatServerDate, parseServerDate, startOfMoscowDay } from './moscowTime';
import { GuestType, PassStatus, type Pass } from './passes';
import type { PassDuration } from './schedule';

/**
 * «Изменить пропуск» (roadmap P0-4). PATCH /v1/passes is blocked by the v1 startsAt check, so editing is
 * «order a new pass with these data, then close the old one». Only an expected pass qualifies: an invite
 * has its own flow, and a guest inside cannot lose the pass they are on.
 */
export function canEditByReplace(status: number): boolean {
  return status === PassStatus.Expected;
}

export interface EditPrefill {
  addressId: number;
  guest: 'vehicle' | 'pedestrian';
  plate: string;
  name: string;
  duration: PassDuration;
  whenId: 'now' | 'date';
  date: string;
  until: string;
  comment: string;
}

const DURATION: Record<number, PassDuration> = { 1: 'oneTime', 2: 'temporary', 3: 'permanent' };
const day = (d: Date) => formatServerDate(d).slice(0, 10);

/** Form values of the new pass that replaces `pass`; a start already in the past becomes «now». */
export function editPrefill(pass: Pass & { comment?: string }, now: Date): EditPrefill {
  const starts = parseServerDate(pass.startsAt);
  const expires = parseServerDate(pass.expiresAt);
  const future = !!starts && startOfMoscowDay(starts) > startOfMoscowDay(now);
  const duration = DURATION[pass.durationType] ?? 'oneTime';
  return {
    addressId: pass.address.id,
    guest: pass.guestType === GuestType.Pedestrian ? 'pedestrian' : 'vehicle',
    plate: pass.guestData?.plateNumber ?? '',
    name: pass.guestData?.name ?? '',
    duration,
    whenId: future ? 'date' : 'now',
    date: future ? day(starts) : '',
    until: duration === 'temporary' && expires ? day(expires) : '',
    comment: pass.comment ?? '',
  };
}
